import { ConflictAction } from './ConflictResolver';
export class PlannerConflictResolver {
    constructor(core) {
        this.core = core;
    }
    deleteAction(entityId) {
        return {
            action: ConflictAction.DELETE_ENTITY,
            params: { entityId }
        };
    }
    addProductAction({ productId, position }) {
        return {
            action: ConflictAction.ADD_PRODUCT,
            params: {
                productId,
                position
            }
        };
    }
    addProductToProductAction({ productRef, parentEntityId, entitiesToAddToCollidingEntityProductIds }) {
        return {
            action: ConflictAction.ADD_PRODUCT_TO_TARGET,
            params: {
                productRef,
                parentEntityId,
                entitiesToAddToCollidingEntityProductIds
            }
        };
    }
    addEntityToTargetAction({ entity, parentEntityId, entitiesToAddToCollidingEntityProductIds }) {
        return {
            action: ConflictAction.ADD_ENTITY_TO_TARGET,
            params: {
                entity,
                parentEntityId,
                entitiesToAddToCollidingEntityProductIds
            }
        };
    }
}
//# sourceMappingURL=plannerConflictResolver.js.map